export const SESSION_RETURN_PATH_KEY = 'sessionReturnPath'
